import { instanceApi, instanceOEF, segundaVersaoOEF } from './api'

export const solicitaCancelamento = ( idAssinatura, motivos ) => instanceOEF.post( `${segundaVersaoOEF}/cancelamento?id=${idAssinatura}`, motivos )

export const obtemMotivosCancelamento = () => instanceOEF.get( `${segundaVersaoOEF}/submotivos-cancelamento` )

export const suspendeAssinatura = ( idAssinatura, motivos ) => instanceOEF.post( `${segundaVersaoOEF}/suspensao?id=${idAssinatura}`, motivos )

export const desfazSolicitacaoCancelamento = idAssinatura => instanceOEF.post( `${segundaVersaoOEF}/desfazer_pedido_cancelamento_usuario?id=${idAssinatura}` )

export const getImagensRetencao = idAssinatura => instanceApi.get( `/v1/cancelamento/imagens-retencao?idAssinatura=${idAssinatura}` )

export const getVideosRetencao = () => instanceApi.get( `/v1/cancelamento/videos-retencao` )

export const getNumeroKitsMulta = idAssinatura => instanceApi.get( `/v1/cancelamento/numero-kits-multa?idAssinatura=${idAssinatura}` )
